export enum EScrollEffect {
    FIXED = 'fixed',
    PARALLAX = 'parallax',
}
